// extracted by mini-css-extract-plugin
export var arrow = "_3r-6";
export var changeItem = "_3r-3";
export var changesHeader = "_3r-1";
export var changesList = "_3r-2";
export var container = "_3r-0";
export var pathLabel = "_3r-4";
export var value = "_3r-7";
export var valuesContainer = "_3r-5";